import { useMutation } from '@apollo/client'

import { mutationRegisterBuyer } from '../mutations/buyers'

export const registerBuyer = () => {
  const response = useMutation(mutationRegisterBuyer)
  return response
}
